import React from 'react';
import { useIntl } from 'react-intl';
import './styles.scss';

const RSDetails = () => {
  const intl = useIntl();
  return (
    <div>
      <h3 className="title">
        {intl.formatMessage({
          id: 'rlms.rateOverview',
          defaultMessage: 'Rate Overview',
        })}
      </h3>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.sc_overview_description',
          defaultMessage: `This is National Grid’s standard electric rate for the majority of our residential customers.`,
        })}
      </p>

      <h3 className="title">
        {intl.formatMessage({
          id: 'rlms.howItWorks',
          defaultMessage: 'How it Works',
        })}
      </h3>
      <div>
        <p className="text link">
          {intl.formatMessage({
            id: 'rlms.vtou_how_it_works_description',
            defaultMessage:
              'Pay a basic service charge, which is the same regardless of how much energy is used during the billing period, and a rate for every kWh used for each month. For the current rates see:',
          })}
        </p>
        <a
          href="https://www.nationalgridus.com/Upstate-NY-Home/Rates/Service-Rates.aspx?regionkey=nyupstate&customertype=home"
          target="_blank"
          rel="noopener noreferrer"
          className="link-underline"
        >
          National Grid service rates.
        </a>
      </div>
      <br />
      <h3 className="title">
        {intl.formatMessage({
          id: 'rlms.whatItMeans',
          defaultMessage: 'What it Means for You',
        })}
      </h3>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.vtou_what_it_means_description',
          defaultMessage:
            'This is likely the residential rate you’re on today if you’re a residential customer. See other EV specific offerings available on the tabs above.',
        })}
      </p>

      <a
        href="https://www.nationalgridus.com/Upstate-NY-Home/Rates/Service-Rates"
        className="cta-btn"
        target="_blank"
        rel="noopener noreferrer"
      >
        {intl.formatMessage({
          id: 'rateDetails.learnMore',
          defaultMessage: 'Learn More about Service Rates',
        })}
      </a>
    </div>
  );
};

export default RSDetails;
